import script from "./GiftStar.vue?vue&type=script&setup=true&lang=js"
export * from "./GiftStar.vue?vue&type=script&setup=true&lang=js"

import "./GiftStar.vue?vue&type=style&index=0&id=4638fd7d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4638fd7d"]])

export default __exports__